import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Observable } from 'rxjs';
import { AppConfig } from 'src/app/config/config';

@Injectable({
  providedIn: 'root'
})
export class BuService {

  private pathApi = this.config.setting['pathApi'] + "bu/";

  constructor(private http: HttpClient, private config: AppConfig) { }
  
  getAll(obj: any): Observable<any> {
    return this.http.post(`${this.pathApi}getAll`, obj);
  } 
  getAllForOptions(utility : number[]): Observable<any> {
    return this.http.post(`${this.pathApi}getAllForOptions`,utility);
  } 
}
